import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { BsModalService } from 'ngx-bootstrap/modal';
import { map, switchMap } from 'rxjs/operators';
import { ConfirmDialogResult } from '../../../core/modal/modal-confirm.component';
import { AppointmentListService } from '../../appointment-list/state/appointment-list.service';
import { AppointmentSettingsComponent } from '../../appointment-settings/appointment-settings.component';
import { AppointmentsActions } from './appointments.actions';

@Injectable()
export class AppointmentsEffects {

    constructor(
        private actions$: Actions,
        private appointmentListService: AppointmentListService,
        private modalService: BsModalService) {
    }
    openConfirmDialog$ = createEffect(() =>
        this.actions$
            .pipe(
                ofType(AppointmentsActions.openAppointmentsSettings),
                switchMap((action: any) => {
                    const modalRef = this.modalService
                        .show(AppointmentSettingsComponent,
                            {
                                initialState: {
                                    okLabel: 'Save',
                                    cancelLabel: 'Close'
                                },
                                backdrop: 'static',
                                class: 'modal-lg',
                                keyboard: false // disable esc key
                            });

                    return modalRef.content.onClose;
                }),
                map((dialogResult: ConfirmDialogResult) => { // map dialog result into action (map function returns observable to action)
                    if (dialogResult.isConfirmed) {
                        // Used cancelled saving
                        return AppointmentsActions.openAppointmentsSettingsCancel();
                    }
                })
            )
    );
}
